<template>
  <v-page-content>
    <h3><em class="fas fa-1x fa-university"></em> Классы ПАО "Газпром"</h3>

    <content-types @filter="getFilteredData" :disable="!loadedBefore"></content-types>
    <div v-if="classes && classes.length && loadedBefore">
      <b-card v-for="oneClass in classes" :key="oneClass.id.toString()"
        no-body
        border-variant="secondary"
        class="overflow-hidden mb-3"
        style="max-width: 100%;"
      >
        <b-row no-gutters>
          <b-col md="4" style="min-width: 300px;max-width: 300px">
            <b-link :to="oneClass.id.toString()" append>
              <b-card-img width="300px" :src="(oneClass.avatar
                && oneClass.files.find((p) => p.id === oneClass.avatar))
                ? '/api/files/' + oneClass.files
                  .find((p) =>p.id === oneClass.avatar).physicalName
                : defaultImage" class="rounded-0">
              </b-card-img>
            </b-link>
          </b-col>
          <b-col md="8">
            <b-card-body :title="oneClass.title
              ? oneClass.title : 'Название отсутствует'">
              <b-card-text>
                <div v-html="oneClass.shortDescription"></div>
              </b-card-text>
              <div class="event__statusBox">
                <b-badge :variant="$_contentMixin_getBadge(oneClass.status)">
                  {{ oneClass.status }}
                </b-badge>
              </div>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <b-alert
      v-else-if="loadedBefore"
      show
      variant="info"
      class="mx-auto"
    >
      Газпром-классы отсутствуют
    </b-alert>
    <template v-else>
      <skeleton-news />
    </template>
  </v-page-content>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import contentMixin from '@/components/helpers/mixins/content-mixin'
import { statusFilters } from '@/config/content/statuses'
import SkeletonNews from '@/components/ui/skeleton/SkeletonNews.vue'

const ContentTypes = () => import('@/components/content/edit/ListGroupButtonContentTypes.vue')

export default {
  name: 'AllClasses',
  components: {
    SkeletonNews,
    ContentTypes
  },
  mixins: [contentMixin],
  data() {
    return {
      defaultImage: '/images/w1400_1.jpg',
      filters: [{
        param: 'status',
        needle: [statusFilters.accepted, statusFilters.rejected, statusFilters.await, statusFilters.draft]
      }],
      loadedBefore: true
    }
  },
  computed: {
    ...mapGetters({
      classes: 'content/getGPClasses'
    })
  },
  methods: {
    ...mapActions({
      fetchClasses: 'content/fetchGPClasses'
    }),
    getFilteredData(type) {
      this.loadedBefore = false
      if (type === 'все') {
        this.filters[0].needle = [
          statusFilters.accepted,
          statusFilters.rejected,
          statusFilters.await,
          statusFilters.draft
        ]
      } else {
        this.filters[0].needle = [type]
      }
      this.fetchClasses(this.filters).then(() => {
        this.loadedBefore = true
      })
    }
  }
}
</script>

<style scoped>
  .fade {
    opacity: 1;
  }
  .fade:hover {
    opacity: 0.6;
  }
</style>
